export default __webpack_public_path__ + "static/media/avtar-2.813233af.png";